module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "用户名",
      "placeholder": "请输入姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.buyer.name),
      callback: function($$v) {
        _vm.$set(_vm.formData.buyer, "name", $$v)
      },
      expression: "formData.buyer.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "type": "text",
      "label": "手机",
      "placeholder": "请输入手机",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.buyer.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData.buyer, "phone", $$v)
      },
      expression: "formData.buyer.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "留言",
      "placeholder": "您还有其他什么要求..."
    },
    model: {
      value: (_vm.formData.buyer.note),
      callback: function($$v) {
        _vm.$set(_vm.formData.buyer, "note", $$v)
      },
      expression: "formData.buyer.note"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.order_list), function(order, index) {
    return _c('div', {
      staticClass: "border-top"
    }, [(order.open_seller_fenxiao == 2) ? _c('div', {
      staticClass: "row-title"
    }, [_c('div', {
      staticClass: "title-left"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": order.business_pic_url,
        "alt": ""
      }
    }), _vm._v("\n                " + _vm._s(order.business_name) + "\n            ")]), _vm._v(" "), (order.coupon_list.length > 0) ? _c('div', {
      staticClass: "title-right",
      on: {
        "click": function($event) {
          return _vm.couponSelect(index)
        }
      }
    }, [_vm._v("\n            选择优惠券(" + _vm._s(order.coupon_list.length) + ")\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((order.goods_items), function(goods, index) {
      return _c('div', {
        staticClass: "flex-between row-between"
      }, [_c('div', {
        staticClass: "between-left flex-start"
      }, [_c('img', {
        staticClass: "between-left-img",
        attrs: {
          "src": goods.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-box"
      }, [_c('div', {
        staticClass: "between-left-title"
      }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "between-left-detail gray-light"
      }, [_vm._v(_vm._s(goods.sku.sku_formart))]), _vm._v(" "), _c('div', {
        staticClass: "between-left-price"
      }, [_vm._v("¥{{goods.price/100")])])]), _vm._v(" "), _c('div', {
        staticClass: "between-right"
      }, [_c('div', {
        staticClass: "between-right-num gray-light"
      }, [_c('span', [_vm._v("数量")]), _vm._v(" " + _vm._s(goods.count))])])])
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _vm._m(1, true)], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer flex-between"
  }, [_vm._m(2), _vm._v(" "), (!_vm.submitLoading) ? _c('div', {
    staticClass: "footer-right",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("去支付")]) : _c('div', {
    staticClass: "footer-right"
  }, [_vm._v("提交中...")])]), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('CouponPicker', {
    attrs: {
      "show": _vm.couponPickerShow,
      "list": _vm.currentCouponList,
      "business_id": _vm.currentBusinessId,
      "index": _vm.currentBusinessIndex
    },
    on: {
      "onChange": _vm.changeCoupon
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-between row-list border-bottom"
  }, [_c('div', [_vm._v("商品金额")]), _vm._v(" "), _c('div', {
    staticClass: "row-right flex-end"
  }, [_vm._v("\n                ¥{{order.goods_price/100\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-between row-list border-bottom"
  }, [_c('div', [_vm._v("优惠")]), _vm._v(" "), _c('div', {
    staticClass: "row-right flex-end"
  }, [_c('span', [_vm._v("¥{{order.discount_price/100")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left flex-start"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("总计")]), _vm._v("¥{{pay_price/100\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cbd2ffb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/order/ShopOrderCheck.vue
// module id = 2464
// module chunks = 0